const UPDATE = 'pulp/reportHash/UPDATE';

export const initialState = '';

export default function reducer(state= initialState, action) {
  switch (action.type) {
    case UPDATE:
      return action.payload;
    default:
      return state;
  }
}

export function updateReportHash(payload) {
  return {
    type: UPDATE,
    payload: payload,
  };
}